import React from 'react'
import { MdAddCircle } from "react-icons/md";

const NewLaneSection = ({t, onClick}: any) =>
  <section className='relative inline-flex'>
    <button
      onClick={onClick}
      className='hover:bg-purple-500 focus:ring-purple-400 focus:ring-offset-purple-100 bg-purple-300 mt-1 py-1 px-2 flex justify-center items-center rounded text-white w-full transition ease-in duration-200 text-center text-base font-semibold shadow-md focus:outline-none focus:ring-2 focus:ring-offset-2'>
        <MdAddCircle className='mr-2'/>
        Nouvelle séquence
      </button>
  </section>

export default NewLaneSection
